import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#E6ECF0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.75 7.125C9.75 7.58913 9.56563 8.03425 9.23744 8.36244C8.90925 8.69063 8.46413 8.875 8 8.875C7.53587 8.875 7.09075 8.69063 6.76256 8.36244C6.43437 8.03425 6.25 7.58913 6.25 7.125C6.25 6.66087 6.43437 6.21575 6.76256 5.88756C7.09075 5.55937 7.53587 5.375 8 5.375C8.46413 5.375 8.90925 5.55937 9.23744 5.88756C9.56563 6.21575 9.75 6.66087 9.75 7.125Z",
      stroke: "#BF211E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.375 7.125C12.375 11.2912 8 13.6875 8 13.6875C8 13.6875 3.625 11.2912 3.625 7.125C3.625 5.96468 4.08594 4.85188 4.90641 4.03141C5.72688 3.21094 6.83968 2.75 8 2.75C9.16032 2.75 10.2731 3.21094 11.0936 4.03141C11.9141 4.85188 12.375 5.96468 12.375 7.125Z",
      stroke: "#BF211E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("line", {
      x1: "0.527056",
      y1: "15.4179",
      x2: "16.5271",
      y2: "2.41792",
      stroke: "#BF211E",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }